import { Card, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Layout from "../../../layout/default";
import Block from "../../../components/Block/Block";
import { Icon } from "../../../components";
import DataTable from "react-data-table-component";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../../services/auth/api";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function UserComissionHistory() {
    const [listData, setListData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [countPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [statusFilter, setStatusFilter] = useState("all");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [dateFilterApplied, setDateFilterApplied] = useState(false);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [hasPreviousPage, setHasPreviousPage] = useState(false);

    useEffect(() => {
        if (!dateFilterApplied) {
            getPayoutList();
        }
    }, [currentPage, statusFilter]);

    const getPayoutList = async () => {
        setLoading(true);

        const authToken = localStorage.getItem('authToken');
        const user_id = localStorage.getItem('user_id');

        const params = {
            page: currentPage,
            per_page: countPerPage,
        };

        if (statusFilter !== "all") {
            params['is_paid[]'] = statusFilter === "paid" ? "1" : "0";
        }

        if (startDate && endDate) {
            params['start_date'] = startDate.toISOString().split('T')[0];
            params['end_date'] = endDate.toISOString().split('T')[0];
        }

        try {
            const response = await api.get(`${process.env.REACT_APP_HOST}api/userpayout`, {
                params,
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            debugger;
            const data = response.data.data;
            const total = response.data.data.length; // Set totalRows based on the correct data length

            setListData(data);
            setTotalRows(total);

            setHasNextPage(countPerPage * currentPage < total);
            setHasPreviousPage(currentPage > 1);
        } catch (error) {
            setListData([]);
            setTotalRows(0);
            setHasNextPage(false);
            setHasPreviousPage(false);
            console.error("Error fetching payout list:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (selectedOption) => {
        setStatusFilter(selectedOption.value);
        setCurrentPage(1);
        setDateFilterApplied(false);
    };

    const handleGoClick = () => {
        if (startDate && endDate) {
            setDateFilterApplied(true);
            getPayoutList();
        } else {
            Swal.fire('Error', 'Please select both start and end date.', 'error');
        }
    };

    const payoutListDataColumns = [
        {
            name: "User ID",
            selector: (row) => row.user_id,
            cell: (row) => <span>{row.user_id}</span>,
            sortable: true,
        },
        {
            name: "Amount",
            selector: (row) => row.amount,
            cell: (row) => <span>{row.amount}</span>,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => row.is_paid ? "Paid" : "Unpaid",
            cell: (row) => <span>{row.is_paid ? "Paid" : "Unpaid"}</span>,
            sortable: true,
        },
        {
            name: "Pinning Group",
            selector: (row) => row.pinning_group_names,
            cell: (row) => (
                <div>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>First Name</th>
                                <th>Middle Name</th>
                                <th>Last Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {row.pinning_group_names.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.first_name}</td>
                                    <td>{item.middle_name}</td>
                                    <td>{item.last_name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ),
            sortable: false,
        },
    ];

    return (
        <Layout title="Payout List">
            <Block.Head>
                <Block.HeadBetween>
                    <Block.HeadContent>
                        <Block.Title tag="h2">Payout List</Block.Title>
                    </Block.HeadContent>
                </Block.HeadBetween>
            </Block.Head>
            <Block>
                <Card>
                    <div className="filter-container mb-3">
                        <div className="row">
                            <div className="col-md-3">
                                <Select
                                    options={[
                                        { value: "all", label: "All" },
                                        { value: "paid", label: "Paid" },
                                        { value: "unpaid", label: "Unpaid" }
                                    ]}
                                    value={{ value: statusFilter, label: statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1) }}
                                    onChange={handleFilterChange}
                                    className="status-filter-select"
                                />
                            </div>
                            <div className="col-md-3">
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    placeholderText="Start Date"
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control"
                                />
                            </div>
                            <div className="col-md-3">
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    placeholderText="End Date"
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control"
                                />
                            </div>
                            <div className="col-md-3">
                                <Button
                                    onClick={handleGoClick}
                                    className="btn btn-primary"
                                    disabled={!startDate || !endDate}
                                >
                                    Go
                                </Button>
                            </div>
                        </div>
                    </div>
                    <DataTable
                        tableClassName="data-table-head-light table-responsive"
                        columns={payoutListDataColumns}
                        data={listData}
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={countPerPage}
                        paginationComponentOptions={{
                            noRowsPerPage: true,
                            next: {
                              disabled: !hasNextPage,
                            },
                            previous: {
                              disabled: !hasPreviousPage,
                            },
                          }}
                        onChangePage={(page) => setCurrentPage(page)}
                        progressPending={loading}
                        theme="solarized"
                    />
                </Card>
            </Block>
        </Layout>
    );
}

export default UserComissionHistory;
